import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ValidateCustomCpf } from '../../shared/validators/type-validators';

@Component({
  selector: 'app-update-cpf',
  templateUrl: './update-cpf.component.html',
  styleUrls: ['./update-cpf.component.scss']
})
export class UpdateCpfComponent implements OnInit {
  updateCpfForm: UntypedFormGroup;
  
  constructor(
    private fb: UntypedFormBuilder,
    private authenticationService: AuthenticationService,
    private router: Router,
    private toastrService: ToastrService,
  ) {}

  ngOnInit(): void {
    this.inicializarFormulario();
  }

  inicializarFormulario() {
    this.updateCpfForm = this.fb.group({
      cpf: [null, [ValidateCustomCpf, Validators.required]]
    });
  }

  onSubmit() {
    if (this.updateCpfForm.invalid) {
      this.updateCpfForm.markAllAsTouched();
      return;
    }

    this.authenticationService.updateCpf({ cpf: this.updateCpfForm.get('cpf').value }).subscribe(
      {
        next: (response) => {
          this.router.navigate(['home']);
        },
        error: (err) => {
          console.error('Erro ao atualizar CPF:', err);
          this.onCancel();
        },
      }
    )
  }

  onCancel() {
    this.authenticationService.logoff()
  }
}
